module.exports = __webpack_public_path__ + "static/media/cookedeel.8fd0bb4f.webp";